import React, { useState } from 'react'

import { Container, Row, InputContainer, Footer } from './styled'
import { Input } from '../../../../components/common/Input'
import { Button } from '../../../../components/common/Button'
import { Modal } from '../../../../components/Modal'

export const Details = ({ onclick, data }) => {
  const [confirmMarkAsRead, setConfirmMarkAsRead] = useState<boolean>(false)
  return (
    <>
      <Container>
        <Row>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Nome do usuário" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.name} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
          <InputContainer width="20%" style={{ alignSelf: 'flex-end' }}>
            <span>Status</span>
            <Button.Root backgroundColor={data.online ? '#665396' : '#F33C3C'}>
              <Button.Content
                title={data.online ? 'Online' : 'Offline'}
                color="#fff"
              />
            </Button.Root>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Função do usuário" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.role} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Posto de trabalho" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.outpost} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Base responsável" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.base} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Telefone" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.phone} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer>
            <Input.Root>
              <Input.Label title="E-mail" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.email} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer>
            <Input.Root>
              <Input.Label title="Último envio - Sempre alerta" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.sent_at} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
          <InputContainer style={{ alignSelf: 'flex-end' }}>
            <span>Respondeu o sempre alerta</span>
            <Button.Root backgroundColor="#000">
              <Button.Content title="NÃO RESPONDIDO" color="#fff" />
            </Button.Root>
          </InputContainer>
        </Row>
        <Row>
          <InputContainer width="49%">
            <Input.Root>
              <Input.Label title="Código encaminhado" />
              <Input.Wrapper backgroundColor="#f7f7f7" outlineColor="#cecece">
                <Input.Content value={data.code} readOnly />
              </Input.Wrapper>
            </Input.Root>
          </InputContainer>
        </Row>
        <Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => setConfirmMarkAsRead((prev) => !prev)}
          >
            <Button.Content title="Marcar como lido" color="#fff" />
          </Button.Root>
        </Footer>
      </Container>
      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmMarkAsRead}
        setIsOpenController={() => setConfirmMarkAsRead(false)}
      >
        <Modal.Header onclick={() => setConfirmMarkAsRead(false)} />
        <Modal.Content
          value="Você deseja marcar como visto?"
          subvalue="Ao clicar em SIM, a notificação irá ser marcada como vista"
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => {
              setConfirmMarkAsRead((prev) => !prev)
            }}
          >
            <Button.Content title="Não" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              onclick([data.id])
              setConfirmMarkAsRead(false)
            }}
          >
            <Button.Content title="Sim" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
